import { useState } from 'react';
import axios from "infra/http";
import { useQuery } from "react-query";

function useBoletosEmRegistro(enabled: boolean = true) {
  const [numeroBoletosEmRegistro, setNumeroBoletosEmRegistro] = useState<number | undefined>();

  useQuery(
    `/v1/conta/boletos-em-registros`,
    async () => {
      const res = await axios.get<{ total: number }>(
        `/v1/conta/boletos-em-registros`
      );

      setNumeroBoletosEmRegistro(res.data.total);
      return res.data;
    },
    {
      enabled: enabled && (!!numeroBoletosEmRegistro || numeroBoletosEmRegistro === undefined),
      refetchInterval: 60 * 1000,
    }

  );

  return {
    numeroBoletosEmRegistro,
    setNumeroBoletosEmRegistro
  }
}

export default useBoletosEmRegistro;
